import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as Tabs from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Tabs";

export const Wrapper = styled.div`
    margin-top: ${theme.space[4]}px;
    margin-bottom: 56px;
`;

export const Header = styled.div`
    text-align: start;
`;

export const TabsWrapper = styled(Tabs.Wrapper)``;

export const Tab = styled(Tabs.Tab)<{ isActive?: boolean }>`
    height: 42px;
    margin-left: 32px;
    padding: 0;
    font-family: ${theme.fonts.bold};
    font-size: 1.4rem;
    letter-spacing: 10%;
    line-height: 1.89rem;
    text-transform: uppercase;
    color: ${({ isActive }) => (isActive ? theme.colors.azure : theme.colors.brushedSteel)};
    opacity: 1;
    &::after {
        width: 100%;
        height: 2px;
        background-color: ${({ isActive }) => (isActive ? theme.colors.azure : "transparent")};
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: 32px;
    }
`;

export const Body = styled.div``;

export const Price = styled.span`
    display: inline-flex;
    align-items: center;
    gap: ${theme.space[1]}px;
    margin-left: ${theme.space[2]}px;
    font-size: 1.4rem;
    letter-spacing: 20%;
    line-height: 2.38rem;
    color: ${theme.colors.brushedSteel};
    @media ${getBreakpoint("up", "lg")} {
        margin-left: 0;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[2]}px;
        @media ${getBreakpoint("up", "lg")} {
            margin-right: 0;
        }
    }
`;

export const Results = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 100%;
    text-align: start;

    @media ${getBreakpoint("up", "lg")} {
        flex-direction: column;
        justify-content: center;
        margin-top: 0;
        padding-top: ${theme.space[3]}px;
    }

    @media ${getBreakpoint("down", "sm")} {
        & > *:not(:first-child):not(:last-child) {
            padding-left: ${theme.space[2]}px;
            padding-right: ${theme.space[2]}px;
        }
    }
`;
